import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=6fb942c5&scoped=true&"
import script from "./Gift.vue?vue&type=script&lang=js&"
export * from "./Gift.vue?vue&type=script&lang=js&"
import style0 from "./Gift.vue?vue&type=style&index=0&id=6fb942c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb942c5",
  null
  
)

component.options.__file = "Gift.vue"
export default component.exports